/* eslint-disable no-undef */
const Config = {
  API_URL: process.env.REACT_APP_API_ENDPOINT,
};

const _AuthHeaders = () => {
  const token = process.env.REACT_APP_TOKEN;
  return {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
  };
};

const connectionHandler = () => navigator.onLine ? true : false;


export const post = async (url, data = {}, { headers, isFormData }) => {

  if (!headers) {
    const data = _AuthHeaders();
    headers = data;
  }

  if (connectionHandler()) {
    return new Promise(async (resolve, reject) => {
      fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
      })
        .then(async (res) => {
          let resData;
          const contentType = res.headers?.get('content-type');
          if (contentType && contentType.indexOf('application/json') !== -1) {
            resData = await res.json();
          } else {
            resData = await res.text();
          }
          if (res.status !== 200) {
            const error = {
              ...resData,
              status: res.status,
              url,
              data: JSON.stringify(data),
            };
            throw error;
          }
          return resData;
        })
        .then((res) => {
          if (res.error) {
            reject(
              res?.errorData
                ? res.errorData.message
                : res.message
                  ? res.message
                  : res.error
            );
          } else {
            resolve(res.result ? res.result : res);
          }
        })
        .catch((err) => {
          errHandler(err);
          reject(err);
        });
    });
  }
};

export const Api = {
  post: (
    url,
    data,
    { headers = _AuthHeaders(), noBaseUrl = false, isFormData = false } = {}
  ) =>
    post(`${noBaseUrl ? url : Config.API_URL + url}`, data, {
      headers,
      isFormData,
    })
};
